module.exports = __webpack_public_path__ + "assets/img/Static_display.3fc9d54d.svg";